import {
    convertPersianDateToUniversalDate,
    convertUniversalDateTimeToPersianDateTime, convertUniversalDateToPersianDate,
    RaikoBaseCardContainer, RaikoCreatorInfo, RaikoCustomSelect, raikoCustomSelectItemGenerator, RaikoDatePicker,
    RaikoGridOneColumn, RaikoGridThreeColumn,
    RaikoGridTwoColumn, RaikoHtmlTextEditor, RaikoLabel, RaikoLabelType,
    RaikoSectionContainer, RaikoSimpleInputOutlined, RaikoToggleOutlined, showServerErrorMessage, showSuccessMessage
} from "@moeindal/base-raiko-panel-components";
import {useEffect, useState} from "react";
import {GamePeriodService} from "../../../serverService/gameService/GamePeriodService";
import {ServerErrorHandler} from "../../../service/errorHandler/ServerErrorHandler";
import CustomHtmlTextEditor from "../../magazine/CustomHtmlTextEditor";
import RaikoEditorHtmlEditor from "../../../raikoComponents/raikoEditor/htmlEditor/RaikoEditorHtmlEditor";
import {GamePeriodsTypes} from "../../../pages/gamePeriod/GamePeriodTypes";

export default function GamePeriodBasicInfo({gamePeriodId}) {

    const service = new GamePeriodService()

    const [title, setTitle] = useState("");
    const [description, setDescription] = useState("")
    const [rules, setRules] = useState("")

    const [registrationStartDate, setRegistrationStartDate] = useState("");
    const [registrationEndDate, setRegistrationEndDate] = useState("");

    const [status, setStatus] = useState("")
    const [createdBy, setCreatedBy] = useState("");
    const [createdAt, setCreatedAt] = useState("");

    const [periodStartDate, setPeriodStartDate] = useState("");
    const [periodEndDate, setPeriodEndDate] = useState("");

    console.log("gamePeriodId", gamePeriodId)

    useEffect(() => {
        service.readBasicInformation(gamePeriodId)
            .then(response => {
                setTitle(response.title);
                setDescription(response.description?response.description :"هیچ توضیحاتی برای ثبت نام این بازی تعریف نشده است")
                setRules(response.rules ? response.rules : "هیچ قانونی برای ثبت نام این بازی تعریف نشده است");
                setCreatedAt(convertUniversalDateTimeToPersianDateTime(response.createdAt));
                setCreatedBy(response.createdBy)

            }).catch(reason => {
            showServerErrorMessage(new ServerErrorHandler(reason).getMessage())
        })

        service.readRegistrationPeriod(gamePeriodId)
            .then(response => {
                setRegistrationStartDate(convertUniversalDateToPersianDate(response.startDate));
                setRegistrationEndDate(convertUniversalDateToPersianDate(response.endDate));
            }).catch(reason => {
            showServerErrorMessage(new ServerErrorHandler(reason).getMessage())
        })

        service.readCompetitionPeriod(gamePeriodId)
            .then(response => {
                setPeriodStartDate(convertUniversalDateToPersianDate(response.startDate));
                setPeriodEndDate(convertUniversalDateToPersianDate(response.endDate));
            }).catch(reason => {
            showServerErrorMessage(new ServerErrorHandler(reason).getMessage())
        })


        service.readAdmissionSetting(gamePeriodId)
            .then(response => {
                setStatus(response.status);
            }).catch(reason => {
            showServerErrorMessage(new ServerErrorHandler(reason).getMessage())
        })

    }, [])


    function handleUpdateGamePeriodBasicInfo() {
        service.updateBasicInformation(
            gamePeriodId,
            title,
            description,
            rules
        ).then(response => {
            showSuccessMessage("بروزرسانی با موفقیت انجام شد.")
        }).catch(reason => {
                showServerErrorMessage(new ServerErrorHandler(reason).getMessage())
            }
        )
    }

    function handleUpdateGameRegisterInfo() {
        service.updateGameRegistrationDate(
            gamePeriodId,
            convertPersianDateToUniversalDate(registrationStartDate),
            convertPersianDateToUniversalDate(registrationEndDate),
        ).then(response => {
            showSuccessMessage("بروزرسانی با موفقیت انجام شد.")
        }).catch(reason => {
            showServerErrorMessage(new ServerErrorHandler(reason).getMessage())

        })
    }

    function handleUpdateGamePeriodDateInfo() {
        service.updateGameCompetitionDate(
            gamePeriodId,
            convertPersianDateToUniversalDate(periodStartDate),
            convertPersianDateToUniversalDate(periodEndDate),
        ).then(response => {
            showSuccessMessage("بروزرسانی با موفقیت انجام شد.")

        }).catch(reason => {
            showServerErrorMessage(new ServerErrorHandler(reason).getMessage())

        })
    }

    function handleUpdateGameRegisterStatus() {
        service.updateGameAdmissionSetting(
            gamePeriodId,
            status
        ).then(response => {
            showSuccessMessage("بروزرسانی با موفقیت انجام شد.")

        }).catch(reason => {
            showServerErrorMessage(new ServerErrorHandler(reason).getMessage())

        })
    }

    return (
        <RaikoGridOneColumn>
            <RaikoBaseCardContainer>
                <RaikoSectionContainer
                    title={"اطلاعات پایه"}
                    hasActionButton
                    actionButtonOnclickWithValidation={handleUpdateGamePeriodBasicInfo}
                >
                    <RaikoGridOneColumn>
                        <RaikoSimpleInputOutlined
                            labelText={"نام دوره"}
                            value={title}
                            setValue={setTitle}
                            required
                        />

                        <RaikoLabel text={"توضیحات دوره"} raikoLabelType={RaikoLabelType.SUBTITLE}/>
                        <RaikoEditorHtmlEditor value={description} setEditorValue={setDescription}/>
                        <RaikoLabel text={"قوانین دوره"} raikoLabelType={RaikoLabelType.SUBTITLE}/>
                        <RaikoEditorHtmlEditor value={rules} setEditorValue={setRules}/>
                    </RaikoGridOneColumn>
                </RaikoSectionContainer>
            </RaikoBaseCardContainer>

            <RaikoBaseCardContainer>
                <RaikoSectionContainer
                    title={"ثبت نام"}
                    subTitle={"محدوده ی زمانی ثبت نام در دوره"}
                    hasActionButton
                    actionButtonTitle={"بروزرسانی"}
                    actionButtonOnclickWithValidation={handleUpdateGameRegisterInfo}
                >
                    <RaikoGridTwoColumn>
                        <RaikoDatePicker
                            label={"تاریخ شروع ثبت نام"}
                            date={registrationStartDate}
                            setDate={setRegistrationStartDate}
                            required
                        />
                        <RaikoDatePicker
                            label={"تاریخ پایان ثبت نام"}
                            date={registrationEndDate}
                            setDate={setRegistrationEndDate}
                            required
                        />
                    </RaikoGridTwoColumn>

                </RaikoSectionContainer>
            </RaikoBaseCardContainer>


            <RaikoBaseCardContainer>
                <RaikoSectionContainer
                    title={"برگزاری"}
                    hasActionButton
                    actionButtonTitle={"بروزرسانی"}
                    subTitle={"محدوده ی زمانی برگزاری بازی"}
                    actionButtonOnclickWithValidation={handleUpdateGamePeriodDateInfo}
                >
                    <RaikoGridTwoColumn>
                        <RaikoDatePicker
                            label={"تاریخ شروع دوره"}
                            date={periodStartDate}
                            setDate={setPeriodStartDate}
                            required
                        />
                        <RaikoDatePicker
                            label={"تاریخ پایان دوره"}
                            date={periodEndDate}
                            setDate={setPeriodEndDate}
                            required
                        />
                    </RaikoGridTwoColumn>

                </RaikoSectionContainer>
            </RaikoBaseCardContainer>

            <RaikoBaseCardContainer>
                <RaikoSectionContainer
                    title={"وضعیت"}
                    hasActionButton
                    actionButtonTitle={"بروزرسانی"}
                    actionButtonOnclick={handleUpdateGameRegisterStatus}
                >
                    <RaikoGridOneColumn>
                        <RaikoCustomSelect
                            labelText={"وضعیت"}
                            value={status}
                            setValue={setStatus}
                            items={[
                                raikoCustomSelectItemGenerator(GamePeriodsTypes.SCHEDULED.id, GamePeriodsTypes.SCHEDULED.title),
                                raikoCustomSelectItemGenerator(GamePeriodsTypes.IN_PROGRESS.id, GamePeriodsTypes.IN_PROGRESS.title),
                                raikoCustomSelectItemGenerator(GamePeriodsTypes.REGISTRATION_OPEN.id, GamePeriodsTypes.REGISTRATION_OPEN.title),
                                raikoCustomSelectItemGenerator(GamePeriodsTypes.COMPLETED.id, GamePeriodsTypes.COMPLETED.title),
                                raikoCustomSelectItemGenerator(GamePeriodsTypes.CANCELLED.id, GamePeriodsTypes.CANCELLED.title),
                            ]}
                        />
                    </RaikoGridOneColumn>

                </RaikoSectionContainer>
            </RaikoBaseCardContainer>
            <RaikoCreatorInfo
                createdBy={createdBy}
                createdAt={createdAt}
            />
        </RaikoGridOneColumn>
    )
}